import axios from 'axios'
import { useAuthStore } from '@/stores/auth'

const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_URL ?? '',
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
})

apiClient.interceptors.request.use((config) => {
  const auth = useAuthStore()
  if (auth.csrfToken && config.method !== 'get') {
    config.headers['X-CSRF-Token'] = auth.csrfToken
  }
  return config
})

// Dynamic import avoids a potential circular dependency between client.ts
// and router/index.ts (router imports guards, guards import stores, stores
// import apiClient). Using import() at call-time keeps the module graph acyclic.
async function redirectToLogin(): Promise<void> {
  const { default: router } = await import('@/router')
  await router.push('/login')
}

apiClient.interceptors.response.use(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  (res) => res.data as any,
  (err: unknown) => {
    if (
      axios.isAxiosError(err) &&
      err.response?.status === 403
    ) {
      const auth = useAuthStore()
      auth.logout()
      void redirectToLogin()
    }
    return Promise.reject(err)
  },
)

export default apiClient
